import { render, staticRenderFns } from "./VehicleList.vue?vue&type=template&id=4b8e6da8"
import script from "./VehicleList.vue?vue&type=script&lang=js"
export * from "./VehicleList.vue?vue&type=script&lang=js"
import style0 from "./VehicleList.vue?vue&type=style&index=0&id=4b8e6da8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports